import {Component, Input, OnInit} from '@angular/core';
import {CommonInputComponent} from '../common-input/common-input.component';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class DatePickerComponent extends CommonInputComponent implements OnInit {
  @Input() isFromDate: boolean;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.actualValue = this.ngModelObject;
  }

  public updateValue(event: any): void {
    this.actualValue = event ? new Date(event.format('YYYY-MM-DD')) : null;
  }
}
